export const MAP_VIEW = 'm';
export const LIST_VIEW = 'l';
